import type { Store } from 'redux';
import type { Epic } from 'redux-observable';
import initiateStore from '@atlassian/jira-common-tangerine/src/state/initiate';
import errorHandlerReduxMiddleware from '@atlassian/jira-errors-handling/src/utils/redux-middleware.tsx';
import { APP_ID } from '../model/constants';
import type { Action } from './actions';
import rootReducer from './reducers/reducer';
import type { State } from './types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	rootEpic?: Epic<Action, State>,
	// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
	onError: (err: Error) => void,
): Store<State> =>
	initiateStore<State, Action, undefined>({
		appName: 'software-reports/velocity-report',
		// @ts-expect-error - Type 'Reducer<CombinedState<{ app: AppState; entities: CombinedState<{ estimationConfig: EstimationConfig; sprints: SprintsState; timeTrackingOptions: TimeTrackingOptions; }>; }>, FetchEstimationConfigSuccess | ... 1 more ... | Action>' is not assignable to type 'Reducer<State, AnyAction>'.
		rootReducer,
		rootEpic,
		middlewares: [errorHandlerReduxMiddleware(APP_ID, null, onError)],
	});
